import React from 'react';
import { Container, Content, ContentContainer, HeaderSection, ImageContainer, Controls } from './AuthLayout.styles';
import SimplrAsurionLogo from '../common/SimplrAsurionLogo';

const AuthLayout = ({ children, controls }) => {
  return (
    <Container>
      <HeaderSection>
        <SimplrAsurionLogo />
      </HeaderSection>
      <ContentContainer>
        <Controls>{controls}</Controls>
        <Content>{children}</Content>
      </ContentContainer>
      <ImageContainer>
        <img src="/images/pre-login-image/pre-login-bg.svg" alt="Illustration" />
      </ImageContainer>
    </Container>
  );
};

export default AuthLayout;
